import React from "react";

import { shortNumberFormat } from "@/utils/numbers";

import { Text } from "../ui";

interface StatusActionCounterProps {
  count?: number;
}

/** Action button numerical counter, eg "5" likes. */
export default function StatusActionCounter({
  count = 0,
}: StatusActionCounterProps) {
  if (!count) {
    return null;
  }

  return (
    <Text size="xs" weight="semibold" theme="inherit">
      {shortNumberFormat(count)}
    </Text>
  );
}
